import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

// Define routes specific to the RD Manager role
export const supervisorRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        '@pages/supervisor/supervisor-dashboard/supervisor-dashboard'
      ).then((m) => m.SupervisorDashboard),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Supervisor',
    },
  },
  {
    path: 'task-monitoring',
    loadComponent: () =>
      import('@pages/supervisor/task-monitoring/task-monitoring').then(
        (m) => m.TaskMonitoring
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Supervisor',
    },
  },
  {
    path: 'task-monitoring/:id/details',
    loadComponent: () =>
      import(
        '@pages/supervisor/task-monitoring/task-allocation/task-allocation'
      ).then((m) => m.TaskAllocation),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Supervisor',
    },
  },
  {
    path: 'data-sync',
    loadComponent: () =>
      import('@pages/supervisor/data-sync/data-sync').then((m) => m.DataSync),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Supervisor',
    },
  },
];
